export default __webpack_public_path__ + "static/media/acercade-icon.9a453185.webp";